import { adminApi } from '../lib/axios';

export const adminInviteService = {
  async createInvite(trialDays?: number) {
    const { data } = await adminApi.post('/brand-admin-invitation/create', { trialDays });
    return data as { token: string; url: string };
  },
  async listInvites() {
    const { data } = await adminApi.get('/brand-admin-invitation/list');
    return data as { items: Array<{ id: string; token: string; shopUrl?: string; used: boolean; usedAt?: string; createdAt: string; sessionId?: string; session?: { brandDetail?: { companyName?: string; brandProfileImage?: string } } }>; pagination: { page: number; limit: number; total: number; totalPages: number } };
  },
  async getOverview() {
    const { data } = await adminApi.get('/brand-admin-invitation/overview');
    return data as { total: number; used: number; unused: number; usageRate: number };
  }
};

export const trialOTPService = {
  async createOTP(trialDays: number, description?: string) {
    const { data } = await adminApi.post('/trial-otp/create', { trialDays, description });
    return data as { id: string; code: string; trialDays: number; description?: string; isActive: boolean; createdAt: string };
  },
  async listOTPs(page = 1, limit = 20) {
    const { data } = await adminApi.get('/trial-otp/list', { params: { page, limit } });
    return data as {
      items: Array<{
        id: string;
        code: string;
        trialDays: number;
        description?: string;
        isActive: boolean;
        createdAt: string;
        updatedAt: string;
        createdBy: { id: string; firstName: string; lastName: string; email: string };
        usageCount: number;
      }>;
      pagination: { page: number; limit: number; total: number; totalPages: number }
    };
  },
  async getOTPDetails(otpId: string) {
    const { data } = await adminApi.get(`/trial-otp/details/${otpId}`);
    return data as {
      id: string;
      code: string;
      trialDays: number;
      description?: string;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
      createdBy: { id: string; firstName: string; lastName: string; email: string };
      usageCount: number;
      usages: Array<{
        id: string;
        activatedAt: string;
        brand: {
          sessionId: string;
          shop: string;
          companyName?: string;
          email?: string;
          profileImage?: string;
        };
      }>;
    };
  },
  async toggleOTPStatus(otpId: string, isActive: boolean) {
    const { data } = await adminApi.patch(`/trial-otp/${otpId}/toggle`, { isActive });
    return data as { id: string; code: string; isActive: boolean };
  }
};


